.pure-g
  .pure-u-1
    div(data-hook="slider")

